export default __webpack_public_path__ + "static/wwc-image5-f9d08ea09ed35db8d1ce5bb79ed5f31e.jpg";